import React, { Component } from 'react';
import { Modal, message } from 'antd';
import API_URL from '../../../../common/url';
import $ from "../../../../common/AjaxRequest";
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';

const SortableItem = SortableElement(({ value }) =>
    <div className="sort-wrap">
        <div className="sort-item" style={{ width: '100%' }}>
            {value.paymentNode}
        </div>
    </div>
);

const SortableList = SortableContainer(({ data }) => {
    return (
        <div className='degreesort'>
            {data.map((item, index) => (
                <SortableItem key={`item-${index}`} index={index} value={item} />
            ))}
        </div>
    );
});

class PaymentPlanSortModal extends Component {
    state = {
        visible: false,
        data: [],
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        const { data } = this.state;
        this.setState({
            data: arrayMove(data, oldIndex, newIndex),
        });
    }

    show = (data) => {
        this.setState({
            visible: true,
            data: data.filter(el => el.byStageName !== '总计'),
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    confirm = () => {
        const { data } = this.state;
        const { activeKey, clinicalQuotationRecordId, loadData } = this.props;
        let sendData = {};  //存放传给后台内容的对象
        if (activeKey == 'FteSimplePaymentPlan') {
            data.map((el, index) => {  
                sendData[`paymentPlanList[${index}].quotationFtePaymentPlanId`] = el.quotationFtePaymentPlanId;
            });
        } else {
            data.map((el, index) => {  
                sendData[`paymentPlanList[${index}].quotationVisitPaymentPlanId`] = el.quotationVisitPaymentPlanId;
            });
        }
        
        const options = {
            method: 'POST',
            url: API_URL.evaluate.sortPaymentPlanList,
            data: { 
                ...sendData,
                clinicalQuotationRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success('排序成功');
                this.hide();
                loadData(clinicalQuotationRecordId, activeKey);
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { data, visible, loading } = this.state;
        return (
            <Modal
                title="调整顺序"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
                width="500px"
                confirmLoading={loading}
            >
                <div>
                    <SortableList data={data} axis="xy" helperClass="sortHelper" onSortEnd={this.onSortEnd} />
                </div>
            </Modal>
        );
    }
}

export default PaymentPlanSortModal;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/PaymentPlanSortModal.js